import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { DialogService } from '../../services/dialog.service';
import { UserService } from '../../services/user.service';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'sd-opp-widget-v2',
  templateUrl: './opp-widget-v2.component.html',
  styleUrls: ['./opp-widget-v2.component.scss']
})
export class OppWidgetV2Component implements OnInit {

    @Input() data: any;
    @Input() myoppStatus:Boolean; // my oppurt. status
    opp: any;
    from = '';
    fromForGA = '';
myOppStatus=false;
    constructor(
        public global: GlobalService,
        public dialog: DialogService,
        public api: ApiService,
        public user: UserService,
        public router: Router
    ) { }

    ngOnInit() {
        if ( !this.data.skeletonLoading ) {
            this.opp = this.data.opp;

            if ( typeof(this.data.from) !== undefined ) {
                this.from = this.data.from;
                this.fromForGA = this.from + ': ' + this.opp.oppor_slug;
            }
        }
        if(this.myoppStatus==true)
        {
           this.myOppStatus=true;
        }
    }

    saveOpportunity(save = 1, upcoming = 0) {
        if ( this.user.status == 0 ) {
            this.dialog.openLoginDialog(3);
        } else if ( this.user.status == 3 ) {
            this.dialog.openUpgradeAccountDialog();
        } else {
            this.global.globalSpinner = true;

            this.api.saveOpportunity(this.opp.oppor_slug, save, upcoming).subscribe(res => {
                this.global.globalSpinner = false;
                // console.log(res);
                if ( res.success ) {
                    this.global.reload();
                    if ( save == 1 ) {
                        this.opp.is_saved = true;
                        this.opp.is_upcoming_saved = true;
                        if ( upcoming == 1 ) {
                            this.dialog.openCustomDialog('opp_notify');
                        } else {
                            if ( this.global.daysLeft(this.opp.last_date_application) < 2 ) {
                                this.dialog.openCustomDialog('opp_save_soon');
                            } else {
                                this.dialog.openCustomDialog('opp_save');
                            }
                        }
                    } else if ( save == 0 ) {
                        this.opp.is_saved = false;
                        this.opp.is_upcoming_saved = false;
                    }
                }
            },
            (err: HttpErrorResponse) => {
                this.global.globalSpinner = false;
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!', err);
                }
            });
        }
    }

    goToOppDetailPage(event) {
        event.stopPropagation();

        if ( this.opp.direct && this.opp.direct !== '' ) {
            location.href = this.opp.direct;
        } else {
            this.router.navigate(['/' + this.global.oppDetailPrefix + '/' + this.opp.oppor_slug]);
        }
    }

    trackOppWidgetEvent(eventCategory, eventAction, eventLabel = this.router.url) {
        if (this.data.dashboardWidgetPosition && this.data.dashboardWidgetPosition > 0) {
            eventLabel = 'P' + this.data.dashboardWidgetPosition + ' ' + eventLabel;
        }
        console.log(eventCategory + ', ' + eventAction + ', ' + eventLabel);
        this.global.trackEvent(eventCategory, eventAction, eventLabel);
    }
}
